<template>
  <div class="social-group">            
    <router-link class="social-group__item" v-for="social in socials" :to="social.link" :key="social.id">
     <social-sharing  :url="url"
                      :title="title"
                      :description="description"
                      :quote="title"
                      hashtags="holywoodskyline"
                      :twitter-user="twitter_user"
                      inline-template>
       <network :network="social.network">                        
      <span class="icon-font">
        <svg-icon :type="social.icon" />
      </span>
      </network>
      </social-sharing>
      
    </router-link>

  </div>
</template>

<script>
import SocialSharing from 'vue-social-sharing'

export default {
  name: 'SocialShare',
    components: {
    SocialSharing
  },
  props: {
    socials: Array,
    title: String,
    url: String,
    twitter_user: String,
    description: String
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/components/social-group";
</style>
